var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8915 4.55809C11.6382 4.70378 12.3245 5.06898 12.8625 5.60696C13.4004 6.14494 13.7656 6.83121 13.9113 7.57795M10.8915 1.5C12.4429 1.67235 13.8896 2.3671 14.9941 3.47018C16.0985 4.57326 16.7951 6.0191 16.9694 7.5703M16.2049 13.6712V15.9648C16.2058 16.1777 16.1621 16.3884 16.0768 16.5835C15.9915 16.7786 15.8664 16.9537 15.7095 17.0977C15.5526 17.2416 15.3674 17.3512 15.1657 17.4194C14.964 17.4876 14.7503 17.513 14.5382 17.4938C12.1857 17.2382 9.92588 16.4343 7.94042 15.1467C6.0932 13.9729 4.52708 12.4068 3.35329 10.5596C2.06123 8.5651 1.25715 6.29431 1.00621 3.93118C0.9871 3.71976 1.01223 3.50669 1.07998 3.30551C1.14774 3.10434 1.25664 2.91948 1.39976 2.7627C1.54287 2.60592 1.71706 2.48066 1.91124 2.39489C2.10542 2.30912 2.31533 2.26472 2.5276 2.26452H4.82117C5.1922 2.26087 5.55189 2.39226 5.83321 2.63419C6.11453 2.87613 6.29828 3.21211 6.35021 3.5795C6.44702 4.31349 6.62655 5.03418 6.88538 5.72781C6.98824 6.00145 7.0105 6.29884 6.94953 6.58474C6.88855 6.87065 6.74689 7.13308 6.54134 7.34095L5.5704 8.31189C6.65874 10.2259 8.24351 11.8107 10.1575 12.899L11.1285 11.9281C11.3363 11.7225 11.5988 11.5809 11.8847 11.5199C12.1706 11.4589 12.468 11.4812 12.7416 11.584C13.4352 11.8429 14.1559 12.0224 14.8899 12.1192C15.2613 12.1716 15.6005 12.3587 15.8429 12.6448C16.0854 12.931 16.2142 13.2962 16.2049 13.6712Z",
    stroke: "#A175FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/CallIcon.5155fba1fd47e165a49135bbb314d2c8.svg";
export { ForwardRef as ReactComponent };